import axios from 'axios';

export const ATTENDANCE_REQUIRED_CODE = 'ATTENDANCE_REQUIRED';
export const ATTENDANCE_STATUS_UNAVAILABLE_CODE = 'ATTENDANCE_STATUS_UNAVAILABLE';
export const ATTENDANCE_REQUIRED_MESSAGE = 'Сначала отметьтесь на терминале завода';

export const isAttendanceRequiredError = (message: string | null | undefined) =>
  message === ATTENDANCE_REQUIRED_MESSAGE;

export const resolveApiErrorMessage = (error: unknown, fallback: string) => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { code?: unknown; message?: unknown } | undefined;
    if (data?.code === ATTENDANCE_REQUIRED_CODE) {
      return ATTENDANCE_REQUIRED_MESSAGE;
    }
    if (data?.code === ATTENDANCE_STATUS_UNAVAILABLE_CODE) {
      return 'Не удалось проверить статус смены';
    }
    if (typeof data?.message === 'string' && data.message.trim()) {
      return data.message;
    }
  }

  return error instanceof Error && error.message ? error.message : fallback;
};
